import type { Deck } from '@/framework/types';
import { slides } from './slides';

const deck: Deck = {
  slug: 'from-topics-to-tables-budapest',
  category: 'event-talks',
  title: 'From Topics to Tables',
  speaker: 'David Kjerrumgaard',
  description:
    'Cataloging streaming data in the Iceberg ecosystem — the fragmentation problem, the streaming-data-catalog pattern, and a connected-vehicle case study.',
  date: '2026-05-20',
  context: 'Budapest AI/ML',
  visibility: 'public',
  slides,
};

export default deck;
